import type { CatalogSpecification } from "./product";
import type { ContentBlockChip } from "./blocks";

// label + icon paired per flag. Icon names are DS Icon component names
// (kebab-case). Centralised so the same flag renders the same icon on every
// product — no per-SKU authoring of presentation in CMS or Algolia.
const COMPLIANCE_CHIP_PRESENTATION: Record<
	keyof NonNullable<CatalogSpecification["complianceFlags"]>,
	{ label: string; icon: string }
> = {
	dishwasherSafe: { label: "Dishwasher safe", icon: "droplet" },
	bpaFree: { label: "BPA-free", icon: "shield" },
	foodSafe: { label: "Food safe", icon: "check-circle" },
	microwaveSafe: { label: "Microwave safe", icon: "zap" },
	freezerSafe: { label: "Freezer safe", icon: "cloud-snow" },
	ovenSafe: { label: "Oven safe", icon: "thermometer" },
	prop65Warning: {
		label: "Contains Prop 65 substances",
		icon: "alert-triangle"
	}
};

export function complianceFlagsToChips(
	flags?: CatalogSpecification["complianceFlags"]
): ContentBlockChip[] {
	if (!flags) return [];
	return (
		Object.keys(COMPLIANCE_CHIP_PRESENTATION) as Array<
			keyof typeof COMPLIANCE_CHIP_PRESENTATION
		>
	)
		.filter((k) => flags[k] === true)
		.map((k) => ({ ...COMPLIANCE_CHIP_PRESENTATION[k] }));
}
